export const EmailSubscribeQuery = `
  "ctaTemplate": ctaTemplate->{
    ...,
  }
`;
